<!-- Legenda + Nastavení průhlednosti k vrstvě -->
<template>
  <LayerDetails
    :layer="layer"
    :openedLayers="openedLayers"
    v-if="
      (layer.captionUrl && !layer.parentId) || layer.activeSublayersCounter > 0
    "
    v-show="layer.hold || layer.activeSublayersCounter > 0"
  >
    <template v-slot:switch-holder>
      <b-icon
        v-if="layer.tooltip"
        icon="question-circle-fill"
        v-b-tooltip.hover.html
        title="layer.tooltip"
      ></b-icon>

      <span
        v-tooltip="`Počet aktivních podvrstev`"
        v-show="layer.activeSublayersCounter > 0"
        >({{ layer.activeSublayersCounter }})
      </span>
    </template>

    <template v-slot:default>
      <button
        @click="openCol(layer.id)"
        v-show="canDisplayTextButton(layer.id)"
      >
        &#60;= Texty
      </button>
      <WizardEventDispatcher
        :event="'click'"
        :target="{ type: 'custom-button', id: button.id }"
        v-for="button in buttons"
        :key="button.id"
      >
        <CustomButton
          :areaId="button.areaId"
          :title="button.title"
          :fontSize="button.style_fontSize"
          :textColor="button.style_textColor"
          :fontWeight="button.style_fontWeight"
          :backgroundColor="button.style_bgColor"
          :destination="button.destination"
        ></CustomButton>
      </WizardEventDispatcher>
      <input
        type="range"
        step="50"
        min="0"
        max="100"
        :value="layer.opacity"
        v-if="layer.type === 'KML'"
        v-on:change="changeOpacityKML([layer.id, $event])"
        v-show="layer.isActive"
      />
      <input
        type="range"
        min="0"
        max="1"
        :value="layer.opacity"
        step="0.1"
        v-else-if="layer.type === 'SVG'"
        v-on:change="changeOpacitySVG([layer.id, $event])"
        v-show="layer.isActive"
      />
      <div v-if="layer.captionUrl">
        <img v-lazy="captionUrl" v-show="layer.isActive" :alt="captionAlt" />
      </div>

      <LayerDetails
        v-for="subLayerId in subLayers"
        :key="`sublayer-${subLayerId}`"
        :layer="layers[subLayerId]"
        :openedLayers="openedLayers"
      >
        <button
          @click="openCol(layer.id, subLayerId)"
          v-show="
            canDisplayTextButton(subLayerId) || canDisplayTextButton(layer.id)
          "
        >
          &#60;= Texty
        </button>
        <div v-show="layers[subLayerId].isActive">
          <input
            type="range"
            step="50"
            min="0"
            max="100"
            :value="layers[subLayerId].opacity"
            v-if="layers[subLayerId].type === 'KML'"
            v-on:change="changeOpacityKML([subLayerId, $event])"
            v-show="layers[subLayerId].isActive"
          />
          <input
            type="range"
            min="0"
            max="1"
            :value="layers[subLayerId].opacity"
            step="0.1"
            v-else-if="layers[subLayerId].type === 'SVG'"
            v-on:change="changeOpacitySVG([subLayerId, $event])"
            v-show="layers[subLayerId].isActive"
          />
          <img
            v-if="layers[subLayerId].captionUrl"
            v-show="layers[subLayerId].isActive"
            v-lazy="getCaptionUrl(layers[subLayerId])"
            :alt="captionAlt"
          />
        </div>
      </LayerDetails>
    </template>
  </LayerDetails>
</template>

<script>
import { LAYERS } from '@/constants/gmaps.js';
import { mapState, mapActions } from 'vuex';
import CustomButton from '@/components/CustomButton.vue';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';
import LayerDetails from '@/components/sidebar/LayerDetails.vue';

export default {
  props: {
    layer: {
      type: Object,
      required: true
    },
    subLayers: {
      type: Array
    },
    openedLayers: {
      type: Array
    },
    buttons: {
      type: Array,
      required: false
    }
  },
  components: {
    CustomButton,
    WizardEventDispatcher,
    LayerDetails
  },
  computed: {
    ...mapState({
      layers: (state) => state.layers.layers,
      layout: (state) => state.general.layout
    }),
    captionUrl() {
      return LAYERS.baseUrl + this.layer.phaseId + '/' + this.layer.captionUrl;
    },
    captionAlt() {
      return 'Legenda ' + this.layer.name;
    }
  },
  mounted: function () {},
  async created() {
    this.$store.dispatch('layers/fetchSubLayers', this.layer.id);
  },
  methods: {
    isOpen: function isOpen(layerId) {
      // @TODO: get rid of this function (duplicated in LayerDetails.vue)
      if (this.openedLayers) {
        let index = this.openedLayers.indexOf(layerId);

        if (index > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
      return true;
    },
    changeOpacitySVG([layerId, el]) {
      this.$store.dispatch('layers/changeSVGOpacity', [
        layerId,
        el.target.value
      ]);
      this.saveLayerOpacity([layerId, el.target.value]);
    },
    changeOpacityKML([layerId, el]) {
      this.$store.dispatch('layers/changeKMLOpacity', [
        layerId,
        el.target.value
      ]);
      this.saveLayerOpacity([layerId, el.target.value]);
    },
    saveLayerOpacity([layerId, opacity]) {
      let obj = {
        ...this.$route.params
      };
      let activeLayers = JSON.parse(obj['activeLayersOpacity']);
      activeLayers = { ...activeLayers };

      //var index = activeLayers.indexOf(layerId)
      var index = activeLayers[layerId];

      if (opacity < 100) {
        activeLayers[layerId] = opacity;
      } else {
        if (index) {
          // Remove layer from array
          delete activeLayers[layerId];
          //activeLayers.splice(index, 1)
        }
      }

      obj['activeLayersOpacity'] = JSON.stringify(activeLayers);

      this.$router.replace({ name: 'base', params: obj }).catch((err) => {});
    },
    canDisplayTextButton(layerId) {
      return (
        !this.layout.sidebarRight ||
        !JSON.parse(this.$route.params.openTexts).includes(layerId)
      );
    },
    openCol(parentId, layerId) {
      this.$store.dispatch('general/setLayoutOption', ['sidebarRight', true]);
      this.$store.dispatch('general/setLayoutOption', ['sidebarLeft', false]);

      // Update URL
      if (this.isOpen(parentId)) {
        if (layerId) {
          this.$store.dispatch(
            'general/setOpenTexts',
            `[${parentId}, ${layerId}]`
          );
        } else {
          this.$store.dispatch('general/setOpenTexts', `[${parentId}]`);
        }
      }
    },
    getCaptionUrl(subLayer) {
      return LAYERS.baseUrl + subLayer.phaseId + '/' + subLayer.captionUrl;
    }
  }
};
</script>

<style scoped>
.single-layer {
  position: relative;
}
.single-layer details summary {
  padding-right: 2.4rem;
}
.switch-holder {
  position: absolute;
  top: 0.6rem;
  right: 0.5rem;
  z-index: 1;
}
</style>
